// Helpers de la Agenda / Citas.

export const ESTADOS_CITA = [
  { clave: 'programada', nombre: 'Programada', color: '#1D4ED8', bg: '#DBEAFE', emoji: '🗓️' },
  { clave: 'confirmada', nombre: 'Confirmada', color: '#7C3AED', bg: '#EDE9FE', emoji: '✅' },
  { clave: 'completada', nombre: 'Completada', color: '#047857', bg: '#D1FAE5', emoji: '🎉' },
  { clave: 'cancelada', nombre: 'Cancelada', color: '#B91C1C', bg: '#FEE2E2', emoji: '✖️' },
  { clave: 'no_asistio', nombre: 'No asistió', color: '#B45309', bg: '#FEF3C7', emoji: '🚫' },
];

export function estadoCitaInfo(clave) {
  return ESTADOS_CITA.find((e) => e.clave === clave) || ESTADOS_CITA[0];
}

export const DURACIONES = [
  { valor: 15, label: '15 min' },
  { valor: 30, label: '30 min' },
  { valor: 45, label: '45 min' },
  { valor: 60, label: '1 hora' },
  { valor: 90, label: '1 h 30 min' },
  { valor: 120, label: '2 horas' },
  { valor: 180, label: '3 horas' },
  { valor: 240, label: '4 horas' },
  { valor: 480, label: 'Todo el día' },
];

// 'YYYY-MM-DD' local de hoy (sin líos de zona horaria).
export function hoyISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Etiqueta amigable del día: Hoy / Mañana / "lunes 29 de sep".
export function etiquetaDia(fechaISO) {
  if (!fechaISO) return '';
  const hoy = hoyISO();
  const d = new Date(fechaISO + 'T00:00:00');
  const manana = new Date(); manana.setDate(manana.getDate() + 1);
  const mananaISO = `${manana.getFullYear()}-${String(manana.getMonth() + 1).padStart(2, '0')}-${String(manana.getDate()).padStart(2, '0')}`;
  if (fechaISO === hoy) return 'Hoy';
  if (fechaISO === mananaISO) return 'Mañana';
  return d.toLocaleDateString('es', { weekday: 'long', day: 'numeric', month: 'short' });
}

// '14:30' → '2:30 PM'. Acepta 'HH:MM' o 'HH:MM:SS'.
export function horaBonita(hora) {
  if (!hora) return '';
  const [h, m] = String(hora).split(':');
  const hh = parseInt(h, 10);
  const ampm = hh >= 12 ? 'PM' : 'AM';
  const h12 = hh % 12 === 0 ? 12 : hh % 12;
  return `${h12}:${m} ${ampm}`;
}

// Agrupa citas por fecha, en orden. Devuelve [{ fecha, citas }].
export function agruparPorDia(citas = []) {
  const mapa = {};
  citas.forEach((c) => { (mapa[c.fecha] = mapa[c.fecha] || []).push(c); });
  return Object.keys(mapa).sort().map((fecha) => ({
    fecha,
    citas: mapa[fecha].sort((a, b) => (a.hora || '99').localeCompare(b.hora || '99')),
  }));
}
